/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface Access {
   /** @format uuid */
   id?: string
   accessLevel?: AccessLevel
   component?: Components
   generalModule?: GeneralModules
   demandComplianceModule?: DemandComplianceModules
   riskManagementModule?: RiskManagementModules
}

/** @format int32 */
export enum AccessLevel {
   NO_ACCESS = 0,
   READ = 1,
   WRITE = 2,
}

export interface ActionPlan {
   /** @format uuid */
   id?: string
   /** @format int32 */
   index?: number | null
   /** @format uuid */
   organisationId?: string
   /** @format uuid */
   demandAnalysisQuestionId?: string | null
   /** @format uuid */
   swotId?: string | null
   /** @format uuid */
   riskId?: string | null
   /** @format uuid */
   costId?: string | null
   /** @format uuid */
   responsibleId?: string | null
   responsible?: UserAccount
   /** @format int32 */
   priority?: number | null
   actionNeeded?: boolean
   /** @format int32 */
   budgetedCost?: number | null
   /** @format date-time */
   deadline?: string | null
   decidedAction?: string | null
   /** @format uuid */
   decidedById?: string | null
   decidedBy?: UserAccount
   decidedActionComment?: string | null
   status?: ActionPlanStatus
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

/** @format int32 */
export enum ActionPlanStatus {
   NotDecided = 0,
   NotToBeAdressed = 1,
   Decided = 3,
}

export interface Activity {
   /** @format uuid */
   id?: string
   /** @format uuid */
   organisationId?: string
   title?: string | null
   description?: string | null
   /** @format date-time */
   startDate?: string
   /** @format date-time */
   endDate?: string
   colorHex?: string | null
   /** @format uuid */
   responsibleId?: string | null
   responsible?: UserAccount
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

export interface ActivityComment {
   /** @format uuid */
   id?: string
   /** @format uuid */
   activityId?: string
   text?: string | null
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

export interface AddDemandAnalysisDTO {
   demandAnalysis?: DemandAnalysis
   demandComplianceModuleIds?: string[] | null
   selectedClauses?: Clause[] | null
   onlyDemandModule?: boolean
   /** @format uuid */
   organisationTypeId?: string
   /** @format uuid */
   organisationSizeId?: string
}

export interface AddRiskAnalysisDTO {
   riskAnalysis?: RiskAnalysis
   /** @format uuid */
   organisationId?: string
}

export interface AddSwotDTO {
   swot?: SWOT
}

export interface AnswerOptionAnalysisQuestion {
   /** @format uuid */
   id?: string
   /** @format uuid */
   demandAnalysisQuestionId?: string
   /** @format uuid */
   demandId?: string | null
   text?: string | null
   /** @format int32 */
   value?: number
   infoLabel?: string | null
   /** @format int32 */
   order?: number
   answerType?: AnswerType
   demandConnection?: boolean
   actionRequired?: boolean
   colorHex?: string | null
}

/** @format int32 */
export enum AnswerType {
   YesNo = 0,
   Compliance = 1,
   OwnAnswers = 2,
   YesNoDontKnow = 3,
}

export interface Clause {
   /** @format uuid */
   id?: string
   /** @format int32 */
   mainNumber?: number
   /** @format int32 */
   subNumber?: number | null
   text?: string | null
   modifiedBy?: string | null
   /** @format date-time */
   modified?: string
   createdBy?: string | null
   /** @format date-time */
   created?: string
   /** @format uuid */
   demandModuleId?: string
}

export interface CollectAndAuthResponse {
   hintCode?: string | null
   status?: string | null
   qrString?: string | null
   /** @format int32 */
   currentTime?: number
   /** @format int32 */
   totalTime?: number
}

/** @format int32 */
export enum Components {
   DEMAND_COMPLIANCE = 0,
   RISK_MANAGEMENT = 1,
   RISK_ECONOMY = 2,
   CALENDAR = 3,
}

export interface ConsequenceAndProbabilityRisk {
   /** @format uuid */
   id?: string
   /** @format uuid */
   riskAnalysisId?: string
   /** @format uuid */
   organisationId?: string
   proposedAction?: string | null
   /** @format int32 */
   estimatedCost?: number | null
   comment?: string | null
   determined?: boolean
   scenario?: string | null
   source?: string | null
   currentState?: string | null
   consequence?: string | null
   underlyingMotivation?: string | null
   /** @format uuid */
   protectedAssetGoalId?: string | null
   protectedAssetGoal?: ProtectedAssetGoal
   /** @format date-time */
   analysed?: string | null
   /** @format uuid */
   analysedById?: string | null
   analysedBy?: UserAccount
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
   /** @format uuid */
   threatId?: string | null
   threat?: Threat
   actionRequired?: boolean
   underlyingAnalysisMotivation?: string | null
   riskLevel?: RiskLevel
   probability?: ProbabilityScale
   consequenceLifeHealth?: ConsequenceScale
   consequenceEconomy?: ConsequenceScale
   consequenceEnviroment?: ConsequenceScale
   consequenceBrand?: ConsequenceScale
}

/** @format int32 */
export enum ConsequenceScale {
   Negligible = 1,
   Mild = 2,
   Significant = 3,
   Serious = 4,
   Severe = 5,
}

export interface Cost {
   /** @format uuid */
   id?: string
   /** @format uuid */
   organisationId?: string
   /** @format uuid */
   financialYearId?: string | null
   workplace?: Workplace
   post?: Post
   /** @format int32 */
   budget?: number | null
   /** @format int32 */
   result?: number | null
   description?: string | null
   actionRequired?: boolean
   proposedAction?: string | null
   /** @format int32 */
   estimatedCost?: number | null
   comment?: string | null
   /** @format date-time */
   proposed?: string
   /** @format uuid */
   proposedById?: string
   proposedBy?: UserAccount
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

/** @format int32 */
export enum CostCategory {
   DamageCosts = 0,
   PreventiveCosts = 1,
   InsuranceCosts = 2,
   SecurityAdministration = 3,
}

/** @format int32 */
export enum DataClassification {
   OpenInformation = 0,
   InternalInformation = 1,
   ConfidentialInformation = 2,
}

export interface DemandAnalysis {
   /** @format uuid */
   id?: string
   name?: string | null
   /** @format int32 */
   order?: number
   /** @format uuid */
   analysisOwnerId?: string
   analysisOwner?: UserAccount
   /** @format date-time */
   analysisStart?: string | null
   /** @format date-time */
   analysisEnd?: string | null
   demandComplianceModules?: string | null
   /** @format uuid */
   workplaceId?: string
   workplace?: Workplace
   /** @format uuid */
   organisationId?: string
   leadershipPerspectives?: string[] | null
   processes?: string[] | null
   subjects?: string[] | null
   comment?: string | null
   status?: DemandAnalysisStatus
   demandLevel?: SubscriptionLevel
   dataClassification?: DataClassification
   questions?: DemandAnalysisQuestion[] | null
   actionPlans?: ActionPlan[] | null
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
   demandAnalysisProcessOwners?: DemandAnalysisProcessOwner[] | null
   /** @format int32 */
   complianceMaxValue?: number | null
   /** @format int32 */
   riskManagementMaxValue?: number | null
   /** @format int32 */
   riskEconomyMaxValue?: number | null
   /** @format double */
   compliancePercentage?: number | null
   /** @format double */
   riskManagementPercentage?: number | null
   /** @format double */
   riskEconomyPercentage?: number | null
   /** @format int32 */
   complianceDifference?: number | null
   /** @format int32 */
   riskManagementDifference?: number | null
   /** @format int32 */
   riskEconomyDifference?: number | null
}

export interface DemandAnalysisDashboardDTO {
   /** @format uuid */
   id?: string
   /** @format double */
   compliancePercentage?: number | null
   /** @format int32 */
   complianceDifference?: number | null
   /** @format double */
   riskManagementPercentage?: number | null
   /** @format int32 */
   riskManagementDifference?: number | null
   /** @format double */
   riskEconomyPercentage?: number | null
   /** @format int32 */
   riskEconomyDifference?: number | null
}

export interface DemandAnalysisDisplayDTO {
   /** @format uuid */
   id?: string
   name?: string | null
   status?: DemandAnalysisStatus
   /** @format uuid */
   createdById?: string
   /** @format uuid */
   analysisOwnerId?: string
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccountDisplayDTO
}

export interface DemandAnalysisProcessOwner {
   /** @format uuid */
   id?: string
   /** @format uuid */
   processId?: string
   process?: Process
   /** @format uuid */
   userAccountId?: string | null
   userAccount?: UserAccount
   ownerFreeText?: string | null
}

export interface DemandAnalysisQuestion {
   /** @format uuid */
   id?: string
   /** @format uuid */
   demandAnalysisId?: string
   /** @format uuid */
   answeredById?: string | null
   answeredBy?: UserAccount
   /** @format uuid */
   answerId?: string | null
   answer?: AnswerOptionAnalysisQuestion
   proposedAction?: string | null
   /** @format int32 */
   estimatedCost?: number | null
   status?: DemandAnalysisQuestionStatus
   text?: string | null
   backgroundInformation?: string | null
   proposedActionTip?: string | null
   answerOptions?: AnswerOptionAnalysisQuestion[] | null
   processes?: string[] | null
   leadershipPerspectives?: string[] | null
   attachment?: FileBlob
   demandText?: string | null
   demandSource?: string | null
   demandUrl?: string | null
   demandUrlText?: string | null
   demandArea?: DemandArea
   demandType?: DemandType
   demandSubType?: DemandSubType
   demandVersion?: string | null
   /** @format int32 */
   number?: number
   /** @format int32 */
   valuation?: number | null
   comment?: string | null
   /** @format uuid */
   updatedAnswerId?: string | null
   updatedAnswer?: AnswerOptionAnalysisQuestion
   /** @format uuid */
   answerUpdatedById?: string | null
   answerUpdatedBy?: UserAccount
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format uuid */
   demandId?: string
   /** @format uuid */
   demandParentId?: string | null
   demandLevel?: DemandLevel
}

export interface DemandAnalysisQuestionActionPlanResponse {
   updatedQuestion?: DemandAnalysisQuestion
   actionPlan?: ActionPlan
}

/** @format int32 */
export enum DemandAnalysisQuestionStatus {
   NotAnswered = 0,
   Answered = 1,
   Determined = 2,
}

/** @format int32 */
export enum DemandAnalysisStatus {
   Draft = 0,
   Ongoing = 1,
   Completed = 2,
}

/** @format int32 */
export enum DemandArea {
   Economy = 0,
   WorkEnviroment = 1,
   Market = 2,
   Staff = 3,
   Security = 4,
   Management = 5,
   ITLaw = 6,
   Production = 7,
}

export interface DemandComplianceModuleDefinition {
   /** @format uuid */
   id?: string
   systemCode?: string | null
   name?: string | null
   /** @format int32 */
   order?: number
   infoLabel?: string | null
   active?: boolean
   modifiedBy?: string | null
   /** @format date-time */
   modified?: string
   createdBy?: string | null
   /** @format date-time */
   created?: string
   clauses?: Clause[] | null
}

/** @format int32 */
export enum DemandComplianceModules {
   WORK_ENVIRONMENT = 0,
   GDPR = 1,
   ISO27001 = 2,
   ISO28000 = 3,
   ISO31000 = 4,
   ISO45000 = 5,
   SSF_CYBER_SECURITY = 6,
   SYSTEMATIC_FIRE_PROTECTION_WORK = 7,
   SECURITY_PROTECTION = 8,
   LAW_FIRM = 9,
   TECHNICAL_INSTALLERS = 10,
   TECHNICAL_CONSULTANTS = 11,
   FR20002022BUSINESSMANAGEMENT = 12,
}

/** @format int32 */
export enum DemandLevel {
   One = 1,
   Two = 2,
   Three = 3,
}

/** @format int32 */
export enum DemandSubType {
   EUDirective = 0,
   Article = 1,
   Law = 2,
   Ordinance = 3,
   Paragraph = 4,
   Regulation = 5,
   GeneralAdvice = 6,
   Guidance = 7,
   ISOStandard = 8,
   DemandElement = 9,
   OtherDemands = 10,
}

/** @format int32 */
export enum DemandType {
   PublicAuthorityDemand = 0,
   IndustryDemand = 1,
   InsuranceDemand = 2,
   GodPraxis = 3,
}

export interface FileBlob {
   /** @format int32 */
   id?: number
   name?: string | null
   /** @format uuid */
   attachmentId?: string
   /** @format byte */
   bytes?: string | null
   /** @format uuid */
   questionId?: string
}

export interface FinancialYear {
   /** @format uuid */
   id?: string
   status?: FinancialYearStatus
   name?: string | null
   /** @format date-time */
   startDate?: string
   /** @format date-time */
   endDate?: string
   dataClassification?: DataClassification
   /** @format int32 */
   budgetedRevenue?: number | null
   comment?: string | null
   /** @format uuid */
   organisationId?: string
   /** @format uuid */
   ownerId?: string
   owner?: UserAccount
   costs?: Cost[] | null
   actionPlans?: ActionPlan[] | null
   workplaces?: Workplace[] | null
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

export interface FinancialYearActionPlanResponse {
   updatedFinancialYear?: FinancialYear
   actionPlan?: ActionPlan
}

export interface FinancialYearDashboardGraphDTO {
   name?: string | null
   /** @format double */
   percentage?: number
   /** @format int32 */
   damageCosts?: number
   /** @format int32 */
   preventiveCosts?: number
   /** @format int32 */
   insuranceCosts?: number
   /** @format int32 */
   securityAdministration?: number
}

export interface FinancialYearDisplayDTO {
   /** @format uuid */
   id?: string
   status?: FinancialYearStatus
   name?: string | null
   /** @format date-time */
   startDate?: string
   /** @format date-time */
   endDate?: string
   /** @format uuid */
   createdById?: string
   /** @format uuid */
   ownerId?: string
   owner?: UserAccountDisplayDTO
}

/** @format int32 */
export enum FinancialYearStatus {
   Ongoing = 0,
   Completed = 1,
}

/** @format int32 */
export enum GeneralModules {
   WORD_LIST = 0,
   INCIDENT_REPORT = 1,
   WHISTLE_BLOWER = 2,
   INSURANCE_REGISTER = 3,
   PHYSICAL_PLANNING = 4,
   SECURITY_SYSTEM = 5,
   ROBUSTER = 6,
   CORPORATE_GROUP = 7,
   CONTRACT_REGISTER = 8,
   SELF_AUDIT = 9,
   SECURITY_ADMINISTRATION = 10,
   PERSONNEL_ANALYSIS = 11,
   EXPORT_MODULE = 12,
   IMPORT_MODULE = 13,
   STATISTICS = 14,
   SAFETY_GUIDE = 15,
}

export interface LatestModifiedDto {
   id?: string | null
   modifiedBy?: string | null
   /** @format date-time */
   modifiedDate?: string
   title?: string | null
}

export interface LatestSWOTAnalysisDTO {
   /** @format uuid */
   id?: string
   name?: string | null
   /** @format date-time */
   startDate?: string | null
   swoTs?: SWOT[] | null
}

export interface LeadershipPerspective {
   /** @format uuid */
   id?: string
   text?: string | null
}

/** @format int32 */
export enum ModuleType {
   GENERAL = 0,
   DEMAND_COMPLIANCE = 1,
   RISK_MANAGEMENT = 2,
   COMPONENT = 3,
}

export interface Modules {
   /** @format uuid */
   id?: string | null
   /** @format uuid */
   organisationId?: string
   moduleType?: ModuleType
   isActivated?: boolean
   generalModule?: GeneralModules
   riskManagementModule?: RiskManagementModules
   component?: Components
   /** @format uuid */
   demandComplianceModuleDefinitionId?: string | null
}

export interface Organisation {
   /** @format uuid */
   id?: string
   name?: string | null
   /** @maxLength 10 */
   organisationNumber?: string | null
   invoiceName?: string | null
   invoiceAddress?: string | null
   /** @format int32 */
   postalCode?: number | null
   county?: string | null
   country?: string | null
   invoiceReference?: string | null
   phoneNumber?: string | null
   email?: string | null
   otherInvoiceDetails?: string | null
   snIs?: SNIOrganisationConnection[] | null
   organisationProcessIds?: string[] | null
   /** @format uuid */
   organisationSizeId?: string
   organisationSize?: OrganisationSize
   /** @format uuid */
   organisationTypeId?: string
   organisationType?: OrganisationType
   partners?: Organisation[] | null
   /** @format date-time */
   modified?: string
   modifiedBy?: string | null
   /** @format date-time */
   created?: string
   createdBy?: string | null
   subscriptions?: SubscriptionLevel[] | null
   modules?: Modules[] | null
   /** @format int32 */
   workplaceLimit?: number
   isPartner?: boolean
   isSandbox?: boolean
   /** @format uuid */
   parentOrganisationId?: string | null
}

export interface OrganisationChangeNotificationDTO {
   organisationName?: string | null
   userName?: string | null
   userEmail?: string | null
   userDetails?: UserDetailsUpdateNotificationDTO
   organisationDetails?: OrganisationDetailsUpdateNotificationDTO
}

export interface OrganisationDetailsUpdateNotificationDTO {
   organisationInvoiceName?: string | null
   invoiceReference?: string | null
   organisationInvoiceAddress?: string | null
   postalCode?: string | null
   county?: string | null
   phoneNumber?: string | null
   email?: string | null
   otherInvoiceDetails?: string | null
}

export interface OrganisationSize {
   /** @format uuid */
   id?: string
   text?: string | null
   /** @format int32 */
   sortOrder?: number
}

export interface OrganisationType {
   /** @format uuid */
   id?: string
   text?: string | null
}

export interface OrganisationWithUserAccountsDTO {
   organisation?: Organisation
   userAccounts?: UserAccount[] | null
   sandboxOrganisations?: SandboxOrganisationDTO[] | null
}

export interface Post {
   /** @format uuid */
   id?: string
   name?: string | null
   costCategory?: CostCategory
}

/** @format int32 */
export enum ProbabilityScale {
   Unlikely = 1,
   LessLikely = 2,
   Possible = 3,
   Likely = 4,
   Probable = 5,
}

export interface Process {
   /** @format uuid */
   id?: string
   text?: string | null
}

export interface ProcessOwner {
   /** @format uuid */
   id?: string
   /** @format uuid */
   organisationId?: string
   processOwnerProcessConnections?: ProcessOwnerProcessConnection[] | null
   workplaces?: Workplace[] | null
   /** @format uuid */
   userAccountId?: string | null
   userAccount?: UserAccount
   ownerFreeText?: string | null
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

export interface ProcessOwnerDto {
   /** @format uuid */
   id?: string
   userAccount?: UserAccount
   ownerFreeText?: string | null
   workplaces?: WorkplaceProcessOwnerDTO[] | null
   processes?: Process[] | null
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   /** @format date-time */
   modified?: string
}

export interface ProcessOwnerProcessConnection {
   /** @format uuid */
   processOwnerId?: string
   processOwner?: ProcessOwner
   /** @format uuid */
   processId?: string
}

export interface ProtectedAssetGoal {
   /** @format uuid */
   id?: string
   type?: ProtectedAssetGoalType
   name?: string | null
   description?: string | null
   /** @format int64 */
   valuation?: number | null
   /** @format date-time */
   valuationDate?: string | null
   process?: string | null
   workplace?: Workplace
   /** @format uuid */
   organisationId?: string
   comment?: string | null
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format uuid */
   createdById?: string
   /** @format date-time */
   created?: string
   createdBy?: UserAccount
}

/** @format int32 */
export enum ProtectedAssetGoalType {
   ProtectedAsset = 0,
   OrganisationalGoal = 1,
}

export interface RiskAnalysis {
   /** @format uuid */
   id?: string
   name?: string | null
   purposeScope?: string | null
   type?: RiskAnalysisType
   limitation?: string | null
   /** @format uuid */
   analysisOwnerId?: string
   analysisOwner?: UserAccount
   /** @format uuid */
   analysisLeaderId?: string | null
   analysisLeader?: UserAccount
   dataClassification?: DataClassification
   /** @format date-time */
   startDate?: string | null
   /** @format date-time */
   endDate?: string | null
   comment?: string | null
   status?: RiskAnalysisStatus
   /** @format uuid */
   organisationId?: string
   simplifiedRisks?: SimplifiedRisk[] | null
   consequenceAndProbabilityRisks?: ConsequenceAndProbabilityRisk[] | null
   threats?: Threat[] | null
   swoTs?: SWOT[] | null
   actionPlans?: ActionPlan[] | null
   workplaces?: Workplace[] | null
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

export interface RiskAnalysisActionPlanResponse {
   updatedAnalysis?: RiskAnalysis
   actionPlan?: ActionPlan
}

export interface RiskAnalysisDisplayDTO {
   /** @format uuid */
   id?: string
   name?: string | null
   type?: RiskAnalysisType
   status?: RiskAnalysisStatus
   /** @format uuid */
   createdById?: string
   /** @format uuid */
   analysisOwnerId?: string
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccountDisplayDTO
}

/** @format int32 */
export enum RiskAnalysisStatus {
   Ongoing = 0,
   Completed = 1,
}

/** @format int32 */
export enum RiskAnalysisType {
   SWOT = 0,
   SimplifiedRiskAnalysis = 1,
   ConsequenceAndProbabilityAnalysis = 2,
}

/** @format int32 */
export enum RiskLevel {
   VeryHigh = 0,
   High = 1,
   Moderate = 2,
   Low = 3,
   VeryLow = 4,
}

/** @format int32 */
export enum RiskManagementModules {
   SWOT_ANALYSIS = 0,
   SIMPLIFIED_RISK_ANALYSIS = 1,
   CONSEQUENCE_AND_PROBABILITY_ANALYSIS = 2,
}

/** @format int32 */
export enum RiskStatus {
   NotAssessed = 0,
   Unacceptable = 1,
   Questionable = 2,
   Acceptable = 3,
}

/** @format int32 */
export enum Role {
   SystemAdministrator = 0,
   User = 1,
}

export interface SNI {
   /** @format uuid */
   id?: string
   department?: string | null
   category?: string | null
   /** @format int32 */
   code?: number
   comment?: string | null
   version?: SNIVersion
}

export interface SNIOrganisationConnection {
   /** @format uuid */
   id?: string
   /** @format uuid */
   organisationId?: string
   /** @format uuid */
   sniId?: string
   sni?: SNI
}

/** @format int32 */
export enum SNIVersion {
   SNI2007 = 2007,
   SNI2025 = 2025,
}

export interface SNIWorkplaceConnection {
   /** @format uuid */
   id?: string
   /** @format uuid */
   workplaceId?: string
   /** @format uuid */
   sniId?: string
   sni?: SNI
}

export interface SWOT {
   /** @format uuid */
   id?: string
   type?: SWOTType
   title?: string | null
   description?: string | null
   /** @format int32 */
   order?: number
   actionRequired?: boolean
   proposedAction?: string | null
   /** @format int32 */
   estimatedCost?: number | null
   comment?: string | null
   determined?: boolean
   /** @format uuid */
   riskAnalysisId?: string | null
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

/** @format int32 */
export enum SWOTType {
   Strength = 0,
   Weakness = 1,
   Opportunity = 2,
   Threat = 3,
}

export interface SandboxOrganisationDTO {
   /** @format uuid */
   id?: string
   /** @format uuid */
   parentOrganisationId?: string
   name?: string | null
   userAccount?: UserAccount
}

export interface SessionIdDTO {
   sessionId?: string | null
}

export interface SimplifiedRisk {
   /** @format uuid */
   id?: string
   /** @format uuid */
   riskAnalysisId?: string
   /** @format uuid */
   organisationId?: string
   proposedAction?: string | null
   /** @format int32 */
   estimatedCost?: number | null
   comment?: string | null
   determined?: boolean
   scenario?: string | null
   source?: string | null
   currentState?: string | null
   consequence?: string | null
   underlyingMotivation?: string | null
   /** @format uuid */
   protectedAssetGoalId?: string | null
   protectedAssetGoal?: ProtectedAssetGoal
   /** @format date-time */
   analysed?: string | null
   /** @format uuid */
   analysedById?: string | null
   analysedBy?: UserAccount
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
   status?: RiskStatus
}

export interface Subject {
   /** @format uuid */
   id?: string
   text?: string | null
}

export interface SubscriptionAndUsersDTO {
   modules?: Modules[] | null
   userAccounts?: UserAccount[] | null
}

/** @format int32 */
export enum SubscriptionLevel {
   DEMO = 0,
   STRATEGIC_DEMAND_ASSESSMENT = 1,
   MANAGEMENT = 2,
   LINE_MANAGER = 3,
   SPECIALIST = 4,
   CONSULTANT = 5,
   ADD_ON = 99,
}

export interface Threat {
   /** @format uuid */
   id?: string
   name?: string | null
   description?: string | null
   underlyingMotivation?: string | null
   /** @format uuid */
   riskAnalysisId?: string | null
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format date-time */
   created?: string
   /** @format uuid */
   createdById?: string
   createdBy?: UserAccount
}

export interface UpsertProcessOwnerDto {
   /** @format uuid */
   organisationId?: string
   /** @format uuid */
   userAccountId?: string | null
   userAccount?: UserAccount
   ownerFreeText?: string | null
   processes?: Process[] | null
   workplaces?: Workplace[] | null
   /** @format uuid */
   modifiedById?: string
   /** @format uuid */
   createdById?: string
}

export interface User {
   /** @format uuid */
   id?: string
   /**
    * @minLength 12
    * @maxLength 12
    */
   personalNumber?: string | null
   /** @format date-time */
   created?: string
}

export interface UserAccount {
   /** @format uuid */
   id?: string
   user?: User
   /** @format uuid */
   organisationId?: string | null
   organisation?: Organisation
   firstName?: string | null
   lastName?: string | null
   email?: string | null
   jobTitle?: string | null
   phoneNumber?: string | null
   role?: Role
   /** @format date-time */
   modified?: string
   modifiedBy?: string | null
   /** @format date-time */
   created?: string
   createdBy?: string | null
   accesses?: Access[] | null
}

export interface UserAccountDisplayDTO {
   firstName?: string | null
   lastName?: string | null
}

export interface UserDetailsUpdateNotificationDTO {
   email?: string | null
   phoneNumber?: string | null
}

export interface Workplace {
   /** @format uuid */
   id?: string
   isDefault?: boolean
   name?: string | null
   address?: string | null
   /** @format int32 */
   postalCode?: number | null
   county?: string | null
   /** @format uuid */
   organisationSizeId?: string
   organisationSize?: OrganisationSize
   snIs?: SNIWorkplaceConnection[] | null
   processOwners?: ProcessOwner[] | null
   description?: string | null
   /** @format int32 */
   cfar?: number | null
   /** @format uuid */
   organisationId?: string
   /** @format date-time */
   modified?: string
   /** @format uuid */
   modifiedById?: string
   modifiedBy?: UserAccount
   /** @format uuid */
   createdById?: string
   /** @format date-time */
   created?: string
   createdBy?: UserAccount
}

export interface WorkplaceProcessOwnerDTO {
   /** @format uuid */
   id?: string
   name?: string | null
}

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
   /** set parameter to `true` for call `securityWorker` for this request */
   secure?: boolean
   /** request path */
   path: string
   /** content type of request body */
   type?: ContentType
   /** query params */
   query?: QueryParamsType
   /** format of response (i.e. response.json() -> format: "json") */
   format?: ResponseFormat
   /** request body */
   body?: unknown
   /** base url */
   baseUrl?: string
   /** request cancellation token */
   cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
   baseUrl?: string
   baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
   securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
   customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
   data: D
   error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
   Json = 'application/json',
   FormData = 'multipart/form-data',
   UrlEncoded = 'application/x-www-form-urlencoded',
   Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
   public baseUrl: string = ''
   private securityData: SecurityDataType | null = null
   private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
   private abortControllers = new Map<CancelToken, AbortController>()
   private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

   private baseApiParams: RequestParams = {
      credentials: 'same-origin',
      headers: {},
      redirect: 'follow',
      referrerPolicy: 'no-referrer',
   }

   constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
      Object.assign(this, apiConfig)
   }

   public setSecurityData = (data: SecurityDataType | null) => {
      this.securityData = data
   }

   protected encodeQueryParam(key: string, value: any) {
      const encodedKey = encodeURIComponent(key)
      return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
   }

   protected addQueryParam(query: QueryParamsType, key: string) {
      return this.encodeQueryParam(key, query[key])
   }

   protected addArrayQueryParam(query: QueryParamsType, key: string) {
      const value = query[key]
      return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
   }

   protected toQueryString(rawQuery?: QueryParamsType): string {
      const query = rawQuery || {}
      const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
      return keys.map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key))).join('&')
   }

   protected addQueryParams(rawQuery?: QueryParamsType): string {
      const queryString = this.toQueryString(rawQuery)
      return queryString ? `?${queryString}` : ''
   }

   private contentFormatters: Record<ContentType, (input: any) => any> = {
      [ContentType.Json]: (input: any) => (input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input),
      [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
      [ContentType.FormData]: (input: any) =>
         Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key]
            formData.append(
               key,
               property instanceof Blob ? property : typeof property === 'object' && property !== null ? JSON.stringify(property) : `${property}`
            )
            return formData
         }, new FormData()),
      [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
   }

   protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
      return {
         ...this.baseApiParams,
         ...params1,
         ...(params2 || {}),
         headers: {
            ...(this.baseApiParams.headers || {}),
            ...(params1.headers || {}),
            ...((params2 && params2.headers) || {}),
         },
      }
   }

   protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
      if (this.abortControllers.has(cancelToken)) {
         const abortController = this.abortControllers.get(cancelToken)
         if (abortController) {
            return abortController.signal
         }
         return void 0
      }

      const abortController = new AbortController()
      this.abortControllers.set(cancelToken, abortController)
      return abortController.signal
   }

   public abortRequest = (cancelToken: CancelToken) => {
      const abortController = this.abortControllers.get(cancelToken)

      if (abortController) {
         abortController.abort()
         this.abortControllers.delete(cancelToken)
      }
   }

   public request = async <T = any, E = any>({
      body,
      secure,
      path,
      type,
      query,
      format,
      baseUrl,
      cancelToken,
      ...params
   }: FullRequestParams): Promise<HttpResponse<T, E>> => {
      const secureParams =
         ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {}
      const requestParams = this.mergeRequestParams(params, secureParams)
      const queryString = query && this.toQueryString(query)
      const payloadFormatter = this.contentFormatters[type || ContentType.Json]
      const responseFormat = format || requestParams.format

      return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
         ...requestParams,
         headers: {
            ...(requestParams.headers || {}),
            ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
         },
         signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
         body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
      }).then(async (response) => {
         const r = response as HttpResponse<T, E>
         r.data = null as unknown as T
         r.error = null as unknown as E

         const data = !responseFormat
            ? r
            : await response[responseFormat]()
                 .then((data) => {
                    if (r.ok) {
                       r.data = data
                    } else {
                       r.error = data
                    }
                    return r
                 })
                 .catch((e) => {
                    r.error = e
                    return r
                 })

         if (cancelToken) {
            this.abortControllers.delete(cancelToken)
         }

         if (!response.ok) throw data
         return data
      })
   }
}

/**
 * @title customerApi
 * @version 1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
   api = {
      /**
       * No description
       *
       * @tags ActionPlanEndpoints
       * @name UpdateActionPlanOnDemandAnalysis
       * @request PUT:/api/ActionPlan/demandAnalysis
       */
      updateActionPlanOnDemandAnalysis: (
         query: {
            /** @format uuid */
            demandAnalysisId: string
         },
         data: ActionPlan,
         params: RequestParams = {}
      ) =>
         this.request<DemandAnalysisQuestionActionPlanResponse, void>({
            path: `/api/ActionPlan/demandAnalysis`,
            method: 'PUT',
            query: query,
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActionPlanEndpoints
       * @name UpdateActionPlanOnRiskAnalysis
       * @request PUT:/api/ActionPlan/riskAnalysis/{analysisId}
       */
      updateActionPlanOnRiskAnalysis: (analysisId: string, data: ActionPlan, params: RequestParams = {}) =>
         this.request<RiskAnalysis, void>({
            path: `/api/ActionPlan/riskAnalysis/${analysisId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActionPlanEndpoints
       * @name UpdateActionPlanOnFinancialYear
       * @request PUT:/api/ActionPlan/financialYear/{financialYearId}
       */
      updateActionPlanOnFinancialYear: (financialYearId: string, data: ActionPlan, params: RequestParams = {}) =>
         this.request<FinancialYear, void>({
            path: `/api/ActionPlan/financialYear/${financialYearId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActivityEndpoints
       * @name AddActivity
       * @request POST:/api/Activity
       */
      addActivity: (data: Activity, params: RequestParams = {}) =>
         this.request<Activity, void>({
            path: `/api/Activity`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActivityEndpoints
       * @name UpdateActivity
       * @request PUT:/api/Activity
       */
      updateActivity: (data: Activity, params: RequestParams = {}) =>
         this.request<Activity, void>({
            path: `/api/Activity`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActivityEndpoints
       * @name GetByOrganisationIdAndYear
       * @request GET:/api/Activity/organisation/{organisationId}/year/{year}
       */
      getByOrganisationIdAndYear: (organisationId: string, year: string, params: RequestParams = {}) =>
         this.request<Activity[], void>({
            path: `/api/Activity/organisation/${organisationId}/year/${year}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActivityEndpoints
       * @name GetLatestActivites
       * @request GET:/api/Activity/{organisationId}
       */
      getLatestActivites: (organisationId: string, params: RequestParams = {}) =>
         this.request<Activity[], void>({
            path: `/api/Activity/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActivityEndpoints
       * @name DeleteActivity
       * @request DELETE:/api/Activity/{activityId}
       */
      deleteActivity: (activityId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Activity/${activityId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActivityCommentEndpoints
       * @name AddActivityComment
       * @request POST:/api/Activity/{activityId}/comments
       */
      addActivityComment: (activityId: string, data: { text: string }, params: RequestParams = {}) =>
         this.request<ActivityComment, void>({
            path: `/api/Activity/${activityId}/comments`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActivityCommentEndpoints
       * @name GetActivityComments
       * @request GET:/api/Activity/{activityId}/comments
       */
      getActivityComments: (activityId: string, params: RequestParams = {}) =>
         this.request<ActivityComment[], void>({
            path: `/api/Activity/${activityId}/comments`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ActivityCommentEndpoints
       * @name DeleteActivityComment
       * @request DELETE:/api/Activity/{activityId}/comments/{commentId}
       */
      deleteActivityComment: (activityId: string, commentId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Activity/${activityId}/comments/${commentId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags AuthEndpoints
       * @name StartBankIdAuthAsync
       * @request POST:/api/Auth/start
       */
      startBankIdAuthAsync: (data: string, params: RequestParams = {}) =>
         this.request<SessionIdDTO, void>({
            path: `/api/Auth/start`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags AuthEndpoints
       * @name CollectBankIdAndIssueTokenAsync
       * @request POST:/api/Auth/collect
       */
      collectBankIdAndIssueTokenAsync: (data: string, params: RequestParams = {}) =>
         this.request<CollectAndAuthResponse, void>({
            path: `/api/Auth/collect`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags AuthEndpoints
       * @name ExchangeMsalTokenIssueJwt
       * @request POST:/api/Auth/exchangeMsalToken
       */
      exchangeMsalTokenIssueJwt: (params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Auth/exchangeMsalToken`,
            method: 'POST',
            ...params,
         }),

      /**
       * No description
       *
       * @tags AuthEndpoints
       * @name CancelBankIdRequestAsync
       * @request POST:/api/Auth/cancel
       */
      cancelBankIdRequestAsync: (data: string, params: RequestParams = {}) =>
         this.request<any, void>({
            path: `/api/Auth/cancel`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            ...params,
         }),

      /**
       * No description
       *
       * @tags AuthEndpoints
       * @name RevokeJwt
       * @request POST:/api/Auth/revokeJwt
       */
      revokeJwt: (params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Auth/revokeJwt`,
            method: 'POST',
            ...params,
         }),

      /**
       * No description
       *
       * @tags AuthEndpoints
       * @name Verify
       * @request POST:/api/Auth/verify
       */
      verify: (params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Auth/verify`,
            method: 'POST',
            ...params,
         }),

      /**
       * No description
       *
       * @tags AuthEndpoints
       * @name GetMe
       * @request GET:/api/Auth/me
       */
      getMe: (params: RequestParams = {}) =>
         this.request<UserAccount, void>({
            path: `/api/Auth/me`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags AuthEndpoints
       * @name GenerateJwt
       * @request POST:/api/Auth/generateJwt/organisation/{organisationId}/userAccount/{userAccountId}
       */
      generateJwt: (organisationId: string, userAccountId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Auth/generateJwt/organisation/${organisationId}/userAccount/${userAccountId}`,
            method: 'POST',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ClauseEndpoints
       * @name GetAllClauses
       * @request GET:/api/Clause
       */
      getAllClauses: (params: RequestParams = {}) =>
         this.request<Clause[], void>({
            path: `/api/Clause`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ClauseEndpoints
       * @name GetClausesByDemandModuleId
       * @request GET:/api/Clause/{demandModuleId}
       */
      getClausesByDemandModuleId: (demandModuleId: string, params: RequestParams = {}) =>
         this.request<Clause[], void>({
            path: `/api/Clause/${demandModuleId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ConsequenceAndProbabilityRiskEndpoints
       * @name AddConsequenceAndProbabilityRisk
       * @request POST:/api/ConsequenceAndProbabilityRisk/add
       */
      addConsequenceAndProbabilityRisk: (data: ConsequenceAndProbabilityRisk, params: RequestParams = {}) =>
         this.request<ConsequenceAndProbabilityRisk, void>({
            path: `/api/ConsequenceAndProbabilityRisk/add`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ConsequenceAndProbabilityRiskEndpoints
       * @name CreateOrUpdateActionPlanForConsequenceAndProbabilityRisk
       * @request POST:/api/ConsequenceAndProbabilityRisk/organisations/{organisationId}/riskAnalysis/{riskAnalysisId}/actionPlan
       */
      createOrUpdateActionPlanForConsequenceAndProbabilityRisk: (
         organisationId: string,
         riskAnalysisId: string,
         data: ConsequenceAndProbabilityRisk,
         params: RequestParams = {}
      ) =>
         this.request<RiskAnalysisActionPlanResponse, void>({
            path: `/api/ConsequenceAndProbabilityRisk/organisations/${organisationId}/riskAnalysis/${riskAnalysisId}/actionPlan`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ConsequenceAndProbabilityRiskEndpoints
       * @name UpdateConsequenceAndProbabilityRisk
       * @request PUT:/api/ConsequenceAndProbabilityRisk/update
       */
      updateConsequenceAndProbabilityRisk: (data: ConsequenceAndProbabilityRisk, params: RequestParams = {}) =>
         this.request<ConsequenceAndProbabilityRisk, void>({
            path: `/api/ConsequenceAndProbabilityRisk/update`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ConsequenceAndProbabilityRiskEndpoints
       * @name GetBiggestRisks
       * @request GET:/api/ConsequenceAndProbabilityRisk/GetBiggestRisks/{organisationId}
       */
      getBiggestRisks: (organisationId: string, params: RequestParams = {}) =>
         this.request<ConsequenceAndProbabilityRisk[], void>({
            path: `/api/ConsequenceAndProbabilityRisk/GetBiggestRisks/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ConsequenceAndProbabilityRiskEndpoints
       * @name DeleteConsequenceAndProbabilityRisk
       * @request DELETE:/api/ConsequenceAndProbabilityRisk/delete/{riskId}
       */
      deleteConsequenceAndProbabilityRisk: (riskId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/ConsequenceAndProbabilityRisk/delete/${riskId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags CostEndpoints
       * @name AddCostToFinancialYear
       * @request POST:/api/Cost/{financialYearId}
       */
      addCostToFinancialYear: (financialYearId: string, data: Cost, params: RequestParams = {}) =>
         this.request<Cost, void>({
            path: `/api/Cost/${financialYearId}`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags CostEndpoints
       * @name UpdateCostOnFinancialYear
       * @request PUT:/api/Cost/{financialYearId}
       */
      updateCostOnFinancialYear: (financialYearId: string, data: Cost, params: RequestParams = {}) =>
         this.request<FinancialYearActionPlanResponse, void>({
            path: `/api/Cost/${financialYearId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags CostEndpoints
       * @name DeleteCost
       * @request DELETE:/api/Cost/delete/{costId}
       */
      deleteCost: (costId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Cost/delete/${costId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisEndpoints
       * @name GetDemandAnalysisById
       * @request GET:/api/DemandAnalysis/{analysisId}/{organisationId}
       */
      getDemandAnalysisById: (analysisId: string, organisationId: string, params: RequestParams = {}) =>
         this.request<DemandAnalysis, void>({
            path: `/api/DemandAnalysis/${analysisId}/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisEndpoints
       * @name AddDemandAnalysis
       * @request POST:/api/DemandAnalysis
       */
      addDemandAnalysis: (data: AddDemandAnalysisDTO, params: RequestParams = {}) =>
         this.request<DemandAnalysis, void>({
            path: `/api/DemandAnalysis`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisEndpoints
       * @name UpdateDemandAnalysis
       * @request PUT:/api/DemandAnalysis
       */
      updateDemandAnalysis: (data: DemandAnalysis, params: RequestParams = {}) =>
         this.request<DemandAnalysis, void>({
            path: `/api/DemandAnalysis`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisEndpoints
       * @name DeleteDemandAnalysisById
       * @request DELETE:/api/DemandAnalysis/{demandAnalysisId}
       */
      deleteDemandAnalysisById: (demandAnalysisId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/DemandAnalysis/${demandAnalysisId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisEndpoints
       * @name GetDemandAnalysisByOrganisationId
       * @request GET:/api/DemandAnalysis/byorganisation{organisationId}
       */
      getDemandAnalysisByOrganisationId: (organisationId: string, params: RequestParams = {}) =>
         this.request<DemandAnalysisDisplayDTO[], void>({
            path: `/api/DemandAnalysis/byorganisation${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisEndpoints
       * @name GetDemandAnalysisDashboardData
       * @request GET:/api/DemandAnalysis/dashboardData/{organisationId}
       */
      getDemandAnalysisDashboardData: (organisationId: string, params: RequestParams = {}) =>
         this.request<DemandAnalysisDashboardDTO, void>({
            path: `/api/DemandAnalysis/dashboardData/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisQuestionEndpoints
       * @name UpdateDemandAnalysisQuestion
       * @request PUT:/api/DemandAnalysisQuestion/{organisationId}
       */
      updateDemandAnalysisQuestion: (organisationId: string, data: DemandAnalysisQuestion, params: RequestParams = {}) =>
         this.request<DemandAnalysisQuestion, void>({
            path: `/api/DemandAnalysisQuestion/${organisationId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisQuestionEndpoints
       * @name CreateActionPlanForDemandAnalysisQuestion
       * @request POST:/api/DemandAnalysisQuestion/organisations/{organisationId}/actionPlan
       */
      createActionPlanForDemandAnalysisQuestion: (organisationId: string, data: DemandAnalysisQuestion, params: RequestParams = {}) =>
         this.request<DemandAnalysisQuestionActionPlanResponse, void>({
            path: `/api/DemandAnalysisQuestion/organisations/${organisationId}/actionPlan`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandAnalysisQuestionEndpoints
       * @name ResetAnswerForDemandAnalysisQuestion
       * @request POST:/api/DemandAnalysisQuestion/organisations/{organisationId}/resetAnswer
       */
      resetAnswerForDemandAnalysisQuestion: (organisationId: string, data: DemandAnalysisQuestion, params: RequestParams = {}) =>
         this.request<DemandAnalysisQuestionActionPlanResponse, void>({
            path: `/api/DemandAnalysisQuestion/organisations/${organisationId}/resetAnswer`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags DemandModuleEndpoints
       * @name GetAllDemandModules
       * @request GET:/api/DemandModule
       */
      getAllDemandModules: (params: RequestParams = {}) =>
         this.request<DemandComplianceModuleDefinition[], void>({
            path: `/api/DemandModule`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags EmailSenderEndpoint
       * @name SendUpdateNotificationToAdmin
       * @request POST:/api/Email/organisationupdate
       */
      sendUpdateNotificationToAdmin: (data: OrganisationChangeNotificationDTO, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Email/organisationupdate`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            ...params,
         }),

      /**
       * No description
       *
       * @tags FileBlobEndpoints
       * @name GetTermsAndConditions
       * @request GET:/api/FileBlob/termsAndConditions
       */
      getTermsAndConditions: (params: RequestParams = {}) =>
         this.request<void, any>({
            path: `/api/FileBlob/termsAndConditions`,
            method: 'GET',
            ...params,
         }),

      /**
       * No description
       *
       * @tags FinancialYearEndpoints
       * @name GetFinancialYearById
       * @request GET:/api/FinancialYear/{financialYearId}/{organisationId}
       */
      getFinancialYearById: (financialYearId: string, organisationId: string, params: RequestParams = {}) =>
         this.request<FinancialYear, void>({
            path: `/api/FinancialYear/${financialYearId}/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags FinancialYearEndpoints
       * @name GetFinancialYearsByOrganisationId
       * @request GET:/api/FinancialYear/byorganisation/{organisationId}
       */
      getFinancialYearsByOrganisationId: (organisationId: string, params: RequestParams = {}) =>
         this.request<FinancialYearDisplayDTO[], void>({
            path: `/api/FinancialYear/byorganisation/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags FinancialYearEndpoints
       * @name GetLatestFinancialYears
       * @request GET:/api/FinancialYear/dashboard/{organisationId}
       */
      getLatestFinancialYears: (organisationId: string, params: RequestParams = {}) =>
         this.request<FinancialYearDashboardGraphDTO[], void>({
            path: `/api/FinancialYear/dashboard/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags FinancialYearEndpoints
       * @name AddFinancialYear
       * @request POST:/api/FinancialYear
       */
      addFinancialYear: (data: FinancialYear, params: RequestParams = {}) =>
         this.request<FinancialYear, void>({
            path: `/api/FinancialYear`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags FinancialYearEndpoints
       * @name UpdateFinancialYear
       * @request PUT:/api/FinancialYear
       */
      updateFinancialYear: (data: FinancialYear, params: RequestParams = {}) =>
         this.request<FinancialYear, void>({
            path: `/api/FinancialYear`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags FinancialYearEndpoints
       * @name CreateOrUpdateFinancialYearActionPlan
       * @request POST:/api/FinancialYear/organisations/{organisationId}/financialYear/{financialYearId}/actionPlan
       */
      createOrUpdateFinancialYearActionPlan: (organisationId: string, financialYearId: string, data: Cost, params: RequestParams = {}) =>
         this.request<FinancialYearActionPlanResponse, void>({
            path: `/api/FinancialYear/organisations/${organisationId}/financialYear/${financialYearId}/actionPlan`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags FinancialYearEndpoints
       * @name DeleteFinancialYear
       * @request DELETE:/api/FinancialYear/{financialYearId}
       */
      deleteFinancialYear: (financialYearId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/FinancialYear/${financialYearId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags LatestModifiedEndpoints
       * @name LatestModified
       * @request GET:/api/LatestModified/admin/{take}
       */
      latestModified: (take: number, params: RequestParams = {}) =>
         this.request<LatestModifiedDto, void>({
            path: `/api/LatestModified/admin/${take}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags LeadershipPerspectiveEndpoints
       * @name GetAllLeadershipPerspectives
       * @request GET:/api/LeadershipPerspective
       */
      getAllLeadershipPerspectives: (params: RequestParams = {}) =>
         this.request<LeadershipPerspective[], void>({
            path: `/api/LeadershipPerspective`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name GetOrganisationById
       * @request GET:/api/Organisation/{id}
       */
      getOrganisationById: (id: string, params: RequestParams = {}) =>
         this.request<Organisation, void>({
            path: `/api/Organisation/${id}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name GetAllOrganisationsByPersonalNumber
       * @request GET:/api/Organisation/byPersonalNumber/{personalNumber}
       */
      getAllOrganisationsByPersonalNumber: (personalNumber: string, params: RequestParams = {}) =>
         this.request<Organisation, void>({
            path: `/api/Organisation/byPersonalNumber/${personalNumber}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name GetOrganisations
       * @request GET:/api/Organisation/admin/organisations
       */
      getOrganisations: (params: RequestParams = {}) =>
         this.request<OrganisationWithUserAccountsDTO[], void>({
            path: `/api/Organisation/admin/organisations`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name AddOrganisation
       * @request POST:/api/Organisation/admin
       */
      addOrganisation: (data: OrganisationWithUserAccountsDTO, params: RequestParams = {}) =>
         this.request<OrganisationWithUserAccountsDTO, void>({
            path: `/api/Organisation/admin`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name UpdateOrganisationAndUserAccounts
       * @request PUT:/api/Organisation/admin/updateOrganisationAndUsers
       */
      updateOrganisationAndUserAccounts: (data: OrganisationWithUserAccountsDTO, params: RequestParams = {}) =>
         this.request<OrganisationWithUserAccountsDTO, void>({
            path: `/api/Organisation/admin/updateOrganisationAndUsers`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name UpgradeSandboxToOrganisation
       * @request PUT:/api/Organisation/admin/upgradeSandboxToOrganisation
       */
      upgradeSandboxToOrganisation: (data: SandboxOrganisationDTO, params: RequestParams = {}) =>
         this.request<void, any>({
            path: `/api/Organisation/admin/upgradeSandboxToOrganisation`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name UpdateOrganisation
       * @request PUT:/api/Organisation
       */
      updateOrganisation: (data: Organisation, params: RequestParams = {}) =>
         this.request<Organisation, void>({
            path: `/api/Organisation`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name DeleteOrganisationById
       * @request DELETE:/api/Organisation/admin/{id}
       */
      deleteOrganisationById: (id: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Organisation/admin/${id}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name UpdateSubscriptionAndUsers
       * @request POST:/api/Organisation/updateSubscriptionAndUsers/{organisationId}
       */
      updateSubscriptionAndUsers: (organisationId: string, data: SubscriptionAndUsersDTO, params: RequestParams = {}) =>
         this.request<SubscriptionAndUsersDTO, void>({
            path: `/api/Organisation/updateSubscriptionAndUsers/${organisationId}`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationEndpoints
       * @name CountOrganisations
       * @request GET:/api/Organisation/admin/count
       */
      countOrganisations: (params: RequestParams = {}) =>
         this.request<number, void>({
            path: `/api/Organisation/admin/count`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationSizeEndpoints
       * @name GetAllOrganisationSizes
       * @request GET:/api/OrganisationSize
       */
      getAllOrganisationSizes: (params: RequestParams = {}) =>
         this.request<OrganisationSize[], void>({
            path: `/api/OrganisationSize`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags OrganisationTypeEndpoints
       * @name GetAllOrganisationTypes
       * @request GET:/api/OrganisationType
       */
      getAllOrganisationTypes: (params: RequestParams = {}) =>
         this.request<OrganisationType[], void>({
            path: `/api/OrganisationType`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags PostEndpoints
       * @name GetAllPosts
       * @request GET:/api/Post
       */
      getAllPosts: (params: RequestParams = {}) =>
         this.request<Post[], void>({
            path: `/api/Post`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProcessEndpoints
       * @name GetAllProcesss
       * @request GET:/api/Process
       */
      getAllProcesss: (params: RequestParams = {}) =>
         this.request<Process[], void>({
            path: `/api/Process`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProcessOwnerEndpoints
       * @name AddProcessOwner
       * @request POST:/api/ProcessOwner
       */
      addProcessOwner: (data: UpsertProcessOwnerDto, params: RequestParams = {}) =>
         this.request<ProcessOwnerDto, void>({
            path: `/api/ProcessOwner`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProcessOwnerEndpoints
       * @name GetAllProcessOwnersByOrganisationId
       * @request GET:/api/ProcessOwner/byOrganisation/{organisationId}
       */
      getAllProcessOwnersByOrganisationId: (organisationId: string, params: RequestParams = {}) =>
         this.request<ProcessOwnerDto[], void>({
            path: `/api/ProcessOwner/byOrganisation/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProcessOwnerEndpoints
       * @name UpdateProcessOwner
       * @request PUT:/api/ProcessOwner/{processOwnerId}
       */
      updateProcessOwner: (processOwnerId: string, data: UpsertProcessOwnerDto, params: RequestParams = {}) =>
         this.request<ProcessOwner, void>({
            path: `/api/ProcessOwner/${processOwnerId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProcessOwnerEndpoints
       * @name DeleteProcessOwner
       * @request DELETE:/api/ProcessOwner/{processOwnerId}
       */
      deleteProcessOwner: (processOwnerId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/ProcessOwner/${processOwnerId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProcessOwnerEndpoints
       * @name GetProcessOwnersByWorkplaceId
       * @request GET:/api/ProcessOwner/{workplaceId}
       */
      getProcessOwnersByWorkplaceId: (workplaceId: string, params: RequestParams = {}) =>
         this.request<ProcessOwnerDto[], void>({
            path: `/api/ProcessOwner/${workplaceId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProcessOwnerEndpoints
       * @name IsProcessOwnerInUse
       * @request GET:/api/ProcessOwner/isInUse/{processOwnerId}
       */
      isProcessOwnerInUse: (processOwnerId: string, params: RequestParams = {}) =>
         this.request<boolean, void>({
            path: `/api/ProcessOwner/isInUse/${processOwnerId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProtectedAssetGoalEndpoints
       * @name GetProtectedAssetGoalById
       * @request GET:/api/ProtectedAssetGoal/{protectedAssetGoalId}
       */
      getProtectedAssetGoalById: (protectedAssetGoalId: string, params: RequestParams = {}) =>
         this.request<ProtectedAssetGoal, void>({
            path: `/api/ProtectedAssetGoal/${protectedAssetGoalId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProtectedAssetGoalEndpoints
       * @name DeleteProtectedAssetGoal
       * @request DELETE:/api/ProtectedAssetGoal/{protectedAssetGoalId}
       */
      deleteProtectedAssetGoal: (protectedAssetGoalId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/ProtectedAssetGoal/${protectedAssetGoalId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProtectedAssetGoalEndpoints
       * @name AddProtectedAssetGoal
       * @request POST:/api/ProtectedAssetGoal
       */
      addProtectedAssetGoal: (data: ProtectedAssetGoal, params: RequestParams = {}) =>
         this.request<ProtectedAssetGoal, void>({
            path: `/api/ProtectedAssetGoal`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProtectedAssetGoalEndpoints
       * @name UpdateProtectedAssetGoal
       * @request PUT:/api/ProtectedAssetGoal
       */
      updateProtectedAssetGoal: (data: ProtectedAssetGoal, params: RequestParams = {}) =>
         this.request<ProtectedAssetGoal, void>({
            path: `/api/ProtectedAssetGoal`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProtectedAssetGoalEndpoints
       * @name GetProtectedAssetGoalsByOrganisationId
       * @request GET:/api/ProtectedAssetGoal/byorganisation/{organisationId}
       */
      getProtectedAssetGoalsByOrganisationId: (organisationId: string, params: RequestParams = {}) =>
         this.request<ProtectedAssetGoal[], void>({
            path: `/api/ProtectedAssetGoal/byorganisation/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProtectedAssetGoalEndpoints
       * @name AddProtectedAssetGoals
       * @request POST:/api/ProtectedAssetGoal/batch
       */
      addProtectedAssetGoals: (data: ProtectedAssetGoal[], params: RequestParams = {}) =>
         this.request<ProtectedAssetGoal[], void>({
            path: `/api/ProtectedAssetGoal/batch`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ProtectedAssetGoalEndpoints
       * @name IsProtectedAssetGoalInUse
       * @request GET:/api/ProtectedAssetGoal/isInUse/{protectedAssetGoalId}
       */
      isProtectedAssetGoalInUse: (protectedAssetGoalId: string, params: RequestParams = {}) =>
         this.request<boolean, void>({
            path: `/api/ProtectedAssetGoal/isInUse/${protectedAssetGoalId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags RiskAnalysisEndpoints
       * @name AddRiskAnalysis
       * @request POST:/api/RiskAnalysis
       */
      addRiskAnalysis: (data: AddRiskAnalysisDTO, params: RequestParams = {}) =>
         this.request<RiskAnalysis, void>({
            path: `/api/RiskAnalysis`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags RiskAnalysisEndpoints
       * @name UpdateRiskAnalysis
       * @request PUT:/api/RiskAnalysis
       */
      updateRiskAnalysis: (data: RiskAnalysis, params: RequestParams = {}) =>
         this.request<RiskAnalysis, void>({
            path: `/api/RiskAnalysis`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags RiskAnalysisEndpoints
       * @name GetRiskAnalysesByOrganisationId
       * @request GET:/api/RiskAnalysis/byorganisation/{organisationId}
       */
      getRiskAnalysesByOrganisationId: (organisationId: string, params: RequestParams = {}) =>
         this.request<RiskAnalysisDisplayDTO[], void>({
            path: `/api/RiskAnalysis/byorganisation/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags RiskAnalysisEndpoints
       * @name GetRiskAnalysisById
       * @request GET:/api/RiskAnalysis/{analysisId}/{organisationId}
       */
      getRiskAnalysisById: (analysisId: string, organisationId: string, params: RequestParams = {}) =>
         this.request<RiskAnalysis, void>({
            path: `/api/RiskAnalysis/${analysisId}/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags RiskAnalysisEndpoints
       * @name DeleteRiskAnalysis
       * @request DELETE:/api/RiskAnalysis/{analysisId}
       */
      deleteRiskAnalysis: (analysisId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/RiskAnalysis/${analysisId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SimplifiedRiskEndpoints
       * @name AddSimplifiedRisk
       * @request POST:/api/SimplifiedRisk/add
       */
      addSimplifiedRisk: (data: SimplifiedRisk, params: RequestParams = {}) =>
         this.request<SimplifiedRisk, void>({
            path: `/api/SimplifiedRisk/add`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SimplifiedRiskEndpoints
       * @name CreateOrUpdateActionPlanForSimplifiedRisk
       * @request POST:/api/SimplifiedRisk/organisations/{organisationId}/riskAnalysis/{riskAnalysisId}/actionPlan
       */
      createOrUpdateActionPlanForSimplifiedRisk: (organisationId: string, riskAnalysisId: string, data: SimplifiedRisk, params: RequestParams = {}) =>
         this.request<RiskAnalysisActionPlanResponse, void>({
            path: `/api/SimplifiedRisk/organisations/${organisationId}/riskAnalysis/${riskAnalysisId}/actionPlan`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SimplifiedRiskEndpoints
       * @name UpdateSimplifiedRisk
       * @request PUT:/api/SimplifiedRisk/update
       */
      updateSimplifiedRisk: (data: SimplifiedRisk, params: RequestParams = {}) =>
         this.request<SimplifiedRisk, void>({
            path: `/api/SimplifiedRisk/update`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SimplifiedRiskEndpoints
       * @name UpdateSimplifiedRiskForRiskAnalysis
       * @request PUT:/api/SimplifiedRisk/risk/{analysisId}
       */
      updateSimplifiedRiskForRiskAnalysis: (analysisId: string, data: SimplifiedRisk, params: RequestParams = {}) =>
         this.request<RiskAnalysis, void>({
            path: `/api/SimplifiedRisk/risk/${analysisId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SimplifiedRiskEndpoints
       * @name DeleteSimplifiedRisk
       * @request DELETE:/api/SimplifiedRisk/delete/{riskId}
       */
      deleteSimplifiedRisk: (riskId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/SimplifiedRisk/delete/${riskId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SNIEndpoints
       * @name GetAllSnis
       * @request GET:/api/SNI
       */
      getAllSnis: (params: RequestParams = {}) =>
         this.request<SNI[], void>({
            path: `/api/SNI`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SubjectEndpoints
       * @name GetAllSubjects
       * @request GET:/api/Subject
       */
      getAllSubjects: (params: RequestParams = {}) =>
         this.request<Subject[], void>({
            path: `/api/Subject`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SWOTEndpoints
       * @name UpdateSwotForRiskAnalysis
       * @request PUT:/api/SWOT/swot/{analysisId}
       */
      updateSwotForRiskAnalysis: (analysisId: string, data: SWOT, params: RequestParams = {}) =>
         this.request<RiskAnalysis, void>({
            path: `/api/SWOT/swot/${analysisId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SWOTEndpoints
       * @name CreateOrUpdateActionPlanForSwot
       * @request PUT:/api/SWOT/organisations/{organisationId}/riskAnalysis/{riskAnalysisId}/actionPlan
       */
      createOrUpdateActionPlanForSwot: (organisationId: string, riskAnalysisId: string, data: SWOT, params: RequestParams = {}) =>
         this.request<RiskAnalysisActionPlanResponse, void>({
            path: `/api/SWOT/organisations/${organisationId}/riskAnalysis/${riskAnalysisId}/actionPlan`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SWOTEndpoints
       * @name AddSwotToRiskAnalysis
       * @request POST:/api/SWOT/{analysisId}
       */
      addSwotToRiskAnalysis: (analysisId: string, data: AddSwotDTO, params: RequestParams = {}) =>
         this.request<RiskAnalysis, void>({
            path: `/api/SWOT/${analysisId}`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SWOTEndpoints
       * @name GetLatestSwotAnalysis
       * @request GET:/api/SWOT/latestSWOTAnalysis/{organisationId}
       */
      getLatestSwotAnalysis: (organisationId: string, params: RequestParams = {}) =>
         this.request<LatestSWOTAnalysisDTO, void>({
            path: `/api/SWOT/latestSWOTAnalysis/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags SWOTEndpoints
       * @name DeleteSwot
       * @request DELETE:/api/SWOT/delete/{swotId}
       */
      deleteSwot: (swotId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/SWOT/delete/${swotId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ThreatEndpoints
       * @name AddThreat
       * @request POST:/api/Threat/{riskAnalysisId}
       */
      addThreat: (riskAnalysisId: string, data: Threat, params: RequestParams = {}) =>
         this.request<Threat, void>({
            path: `/api/Threat/${riskAnalysisId}`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ThreatEndpoints
       * @name UpdateThreat
       * @request PUT:/api/Threat/{riskAnalysisId}
       */
      updateThreat: (riskAnalysisId: string, data: Threat, params: RequestParams = {}) =>
         this.request<RiskAnalysis, void>({
            path: `/api/Threat/${riskAnalysisId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags ThreatEndpoints
       * @name DeleteThreat
       * @request DELETE:/api/Threat/{threatId}
       */
      deleteThreat: (threatId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Threat/${threatId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags UserAccountEndpoints
       * @name GetUserAccount
       * @request GET:/api/UserAccount
       */
      getUserAccount: (params: RequestParams = {}) =>
         this.request<UserAccount, void>({
            path: `/api/UserAccount`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags UserAccountEndpoints
       * @name AddUserAccount
       * @request POST:/api/UserAccount
       */
      addUserAccount: (data: UserAccount, params: RequestParams = {}) =>
         this.request<UserAccount, void>({
            path: `/api/UserAccount`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags UserAccountEndpoints
       * @name UpdateUserAccount
       * @request PUT:/api/UserAccount
       */
      updateUserAccount: (data: UserAccount, params: RequestParams = {}) =>
         this.request<UserAccount, void>({
            path: `/api/UserAccount`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags UserAccountEndpoints
       * @name DeleteUserAccountById
       * @request DELETE:/api/UserAccount/{id}
       */
      deleteUserAccountById: (id: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/UserAccount/${id}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags UserAccountEndpoints
       * @name GetUserAccountsByOrganisationId
       * @request GET:/api/UserAccount/byorganisation/{organisationId}
       */
      getUserAccountsByOrganisationId: (organisationId: string, params: RequestParams = {}) =>
         this.request<UserAccount[], void>({
            path: `/api/UserAccount/byorganisation/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags WorkplaceEndpoints
       * @name GetWorkplaceById
       * @request GET:/api/Workplace/{workplaceId}
       */
      getWorkplaceById: (workplaceId: string, params: RequestParams = {}) =>
         this.request<Workplace, void>({
            path: `/api/Workplace/${workplaceId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags WorkplaceEndpoints
       * @name DeleteWorkplace
       * @request DELETE:/api/Workplace/{workplaceId}
       */
      deleteWorkplace: (workplaceId: string, params: RequestParams = {}) =>
         this.request<void, void>({
            path: `/api/Workplace/${workplaceId}`,
            method: 'DELETE',
            ...params,
         }),

      /**
       * No description
       *
       * @tags WorkplaceEndpoints
       * @name AddWorkplace
       * @request POST:/api/Workplace/{organisationId}
       */
      addWorkplace: (organisationId: string, data: Workplace, params: RequestParams = {}) =>
         this.request<Workplace, void>({
            path: `/api/Workplace/${organisationId}`,
            method: 'POST',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags WorkplaceEndpoints
       * @name UpdateWorkplace
       * @request PUT:/api/Workplace/{organisationId}
       */
      updateWorkplace: (organisationId: string, data: Workplace, params: RequestParams = {}) =>
         this.request<Workplace, void>({
            path: `/api/Workplace/${organisationId}`,
            method: 'PUT',
            body: data,
            type: ContentType.Json,
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags WorkplaceEndpoints
       * @name GetWorkplacesByOrganisationId
       * @request GET:/api/Workplace/byorganisation/{organisationId}
       */
      getWorkplacesByOrganisationId: (organisationId: string, params: RequestParams = {}) =>
         this.request<Workplace[], void>({
            path: `/api/Workplace/byorganisation/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags WorkplaceEndpoints
       * @name GetDefaultWorkplace
       * @request GET:/api/Workplace/defaultWorkplace/{organisationId}
       */
      getDefaultWorkplace: (organisationId: string, params: RequestParams = {}) =>
         this.request<Workplace, void>({
            path: `/api/Workplace/defaultWorkplace/${organisationId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),

      /**
       * No description
       *
       * @tags WorkplaceEndpoints
       * @name IsWorkplaceInUse
       * @request GET:/api/Workplace/isInUse/{workplaceId}
       */
      isWorkplaceInUse: (workplaceId: string, params: RequestParams = {}) =>
         this.request<boolean, void>({
            path: `/api/Workplace/isInUse/${workplaceId}`,
            method: 'GET',
            format: 'json',
            ...params,
         }),
   }
}
